var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contont"},[_c('div',{staticClass:"contont_one"},[_c('Four'),_c('EFive')],1),_c('div',{staticClass:"contont_two"},[_c('Four'),_c('Efour')],1),_c('div',{staticClass:"contont_three"},[_c('Four'),_c('Esix')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }